/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Laps_Device_DescInputs */

const en_ui_laps_device_desc = /** @type {(inputs: Ui_Laps_Device_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} laps from your watch`)
};

const de_ui_laps_device_desc = /** @type {(inputs: Ui_Laps_Device_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Runden von deiner Uhr`)
};

/**
* | output |
* | --- |
* | "{count} laps from your watch" |
*
* @param {Ui_Laps_Device_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_device_desc = /** @type {((inputs: Ui_Laps_Device_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Device_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_device_desc(inputs)
	return de_ui_laps_device_desc(inputs)
});